// src/auth/permissions.js
// Permissoes vem SEMPRE do cadastro do usuario (nunca do nome/login).
// O backend e quem decide; aqui so mostramos/escondemos telas.

// Modulos basicos liberados para qualquer usuario logado que ainda
// nao tenha nenhuma permissao marcada no cadastro: SOMENTE Dashboard e Producao.
export const BASIC_PERMS = new Set([
  'dashboard',
  'extrusao',
  'impressao',
  'corte',
  'expedicao',
]);

// Permissoes especiais (o superAdmin tem todas).
export const SPECIAL_PERMS = {
  GERENCIAR_CONVITES: 'gerenciar_convites',
  CONTAS_SHOPEE: 'contas_shopee',
};

export function getUserName(user) {
  if (!user) return '';
  if (typeof user === 'string') return user;
  if (typeof user === 'object') {
    return user.usuario || user.nome || '';
  }
  return String(user);
}

function permList(value) {
  return Array.isArray(value) ? value : [];
}

export function isSuperAdmin(user) {
  if (!user || typeof user !== 'object') return false;
  return user.superAdmin === true || Number(user.superAdmin) === 1;
}

export function hasSpecialPerm(user, perm) {
  if (isSuperAdmin(user)) return true;
  return permList(user?.permissoes).includes(perm);
}

export function can(user, permKey) {
  if (!user) return false;
  const username = getUserName(user);
  if (!username) return false;
  if (typeof user !== 'object') return BASIC_PERMS.has(permKey);

  if (permList(user.permissoesExtras).includes(permKey)) return true;

  const arr = permList(user.permissoes);
  if (arr.length > 0) return arr.includes(permKey);
  return BASIC_PERMS.has(permKey);
}
export function podeAcessarSaude(user) {
  if (!user || typeof user !== 'object') return false;
  const role = String(user.role || '').toLowerCase();
  const isSuper = user.superAdmin === true || Number(user.superAdmin) === 1;
  return role === 'admin' || user.isAdmin === true || isSuper;
}
